import { gql } from "@apollo/client/core";

export const CREATE_ORGANIZATION = gql`
  mutation($organization: OrganizationInput!) {
    createOrganization(organizationInput: $organization) {
      isValidResponse
      errors
    }
  }
`;
